import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import styles from './DropdownMenuElem.module.scss';
const DropdownMenuElem = ({ children, className, onClick, isActive }) => {
    return (_jsx("li", Object.assign({ className: cn(styles.element, className, isActive && styles['isActive']), onClick: onClick }, { children: children })));
};
export default DropdownMenuElem;
